<template>
  <b-button
    ref="submit"
    sm
    :variant="variant || 'primary'"
    class="mr-2 text-medium submit-btn"
    :type="type"
    :class="{
      'button-confettis': showConfettis,
      'confettis-on': animateConfettis,
      [submitBtnClass]: true
    }"
    :disabled="isLoading || isSubmitDisabled"
    @click="$emit('save', $event)"
    pill
    :data-confettis="showConfettis"
  >
    <b-spinner small v-if="isLoading"></b-spinner>
    <template v-else>
      {{ btnText }}
    </template>
  </b-button>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'

/**
 * This gives a button that can generally be used for Save action. It shows spinner if button goes into loading state. It also supports showing confetti on button.
 */
export default {
  name: 'SaveButton',
  props: [
    'btnText',
    'showConfettis',
    'animateConfettis',
    'submitBtnClass',
    'isLoading',
    'isSubmitDisabled',
    'type',
    'variant'
  ],
  components: {
    BButton,
    BSpinner
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.submit-btn {
  padding: 4px 16px;
}
</style>

<style lang="scss">
@import '~@/styles/components/buttonConfetti';
</style>
